import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
// import difficulty from './modules/difficulty'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    // difficulty,
  }
})
